export default __webpack_public_path__ + "static/media/modal_plus_icon.b8c81593.svg";